import { Code, ConnectError, createClient, Interceptor } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { AuthenticationService } from '../gen/proto/gateway/v1/auth_pb';
import { DeviceService } from '../gen/proto/gateway/v1/device_pb';
import { DeviceDataService } from '../gen/proto/gateway/v1/device_data_pb';
import { signInPath } from '../routes.constants';
import useAuthStore from '../stores/auth.store';
import { authApi } from './auth.api';

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const authInterceptor: Interceptor = (next) => async (req) => {
  const token = useAuthStore.getState().authToken;
  if (token) req.header.set('Authorization', `Bearer ${token}`);
  try {
    return await next(req);
  } catch (error) {
    if (error instanceof ConnectError && error.code === Code.Unauthenticated) {
      const refreshedToken = await authApi.refreshToken();
      if (refreshedToken) {
        req.header.set('Authorization', `Bearer ${refreshedToken}`);
        return await next(req);
      }
      await useAuthStore.getState().logout();
      window.location.assign(signInPath);
    }
    throw error;
  }
};

const transport = createConnectTransport({ baseUrl, interceptors: [authInterceptor] });
const authTransport = createConnectTransport({ baseUrl });

export const authClient = createClient(AuthenticationService, authTransport);
export const deviceClient = createClient(DeviceService, transport);
export const deviceDataClient = createClient(DeviceDataService, transport);
